import apiClients from "../api/axiosConfig";

export const getFees = (request) =>
    apiClients.feesAPI.post(`/api/v2/feeAdmin/getFees`, request);

export const updateFee = async (request) =>
    apiClients.feesAPI.put(`/api/v1/feeAdmin/updateFee`, request);

export const createFee = async (request) =>
    apiClients.feesAPI.post(`/api/v1/feeAdmin/createFee`, request);

export const deleteFees = async (request) =>
    apiClients.feesAPI.put(`/api/v1/feeAdmin/DeleteFee`, request);

export const getChangeLog = async (request) =>
    apiClients.feesAPI.post(`/api/v1/feeAdmin/getChangeLog`, request);
